import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Button, Field, Input, ThemeToggle } from '../../components/ui';
import { AuthorFooter } from './AuthorFooter';
import logo from '../../assets/logo.png';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError('');

    const result = await login(email, password);
    // Przy powodzeniu komponent zniknie razem ze zmianą stanu uwierzytelnienia,
    // więc setState wykonujemy tylko dla ścieżki błędu.
    if (!result.ok) {
      setError(result.error);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-app">
      {/* Panel marki — ukryty na wąskich ekranach, żeby formularz dostał całą szerokość. */}
      <div className="relative hidden w-1/2 flex-col justify-between border-r border-line bg-elevated p-10 lg:flex">
        {/* Logo jest plikiem PNG z kanałem alfa i granatowo-niebieską kreską,
            więc czyta się na tle jasnym i ciemnym bez osobnych wariantów.

            `self-start` jest konieczne: ten panel to kolumnowy kontener flex,
            w którym domyślne align-items: stretch rozciąga element na całą
            szerokość osi poprzecznej. Bez tego `w-auto` przegrywa z
            rozciąganiem i logo wychodzi spłaszczone na szerokość panelu. */}
        <img
          src={logo}
          alt="MAG — Morska Agencja Gdynia"
          width={245}
          height={115}
          className="h-11 w-auto self-start"
        />

        <div className="max-w-md">
          <h1 className="text-3xl font-semibold leading-tight tracking-tight text-content">
            Panel operacyjny depotu kontenerowego
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-muted">
            Awizacje, gate-in i gate-out, stany placu, rozliczenia składowania i THC —
            w jednym miejscu, w czasie rzeczywistym.
          </p>
        </div>

        <AuthorFooter />
      </div>

      <div className="flex w-full flex-col lg:w-1/2">
        <div className="flex justify-end p-4">
          <ThemeToggle />
        </div>

        <div className="flex flex-1 items-center justify-center px-6">
          <div className="w-full max-w-sm">
            <div className="mb-8">
              {/* Na wąskim ekranie panel marki jest ukryty, więc logo musi
                  pojawić się nad formularzem — inaczej na telefonie nie byłoby
                  go nigdzie widać. */}
              <img
                src={logo}
                alt="MAG — Morska Agencja Gdynia"
                width={245}
                height={115}
                className="mb-6 h-10 w-auto lg:hidden"
              />
              <h2 className="text-xl font-semibold tracking-tight text-content">Logowanie</h2>
              <p className="mt-1.5 text-sm text-muted">Zaloguj się do panelu MGDPT.PL.</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <Field label="Adres e-mail" required>
                <Input
                  type="email"
                  autoComplete="email"
                  required
                  autoFocus
                  placeholder="operator@firma.pl"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </Field>

              <Field label="Hasło" required>
                <Input
                  type="password"
                  autoComplete="current-password"
                  required
                  placeholder="••••••••"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
              </Field>

              {error && (
                <p
                  role="alert"
                  className="rounded-md border border-danger-line bg-danger-soft px-3 py-2 text-xs font-medium text-danger"
                >
                  {error}
                </p>
              )}

              <Button
                type="submit"
                variant="primary"
                size="lg"
                loading={isSubmitting}
                className="w-full"
              >
                {isSubmitting ? 'Logowanie…' : 'Zaloguj się'}
              </Button>
            </form>
          </div>
        </div>

        {/* Ta sama stopka co w panelu marki, pokazywana tylko wtedy, gdy panel
            jest ukryty — dzięki temu informacja o autorze nie znika na telefonie
            i nie dubluje się na szerokim ekranie. */}
        <AuthorFooter className="px-6 pb-6 text-center lg:hidden" />
      </div>
    </div>
  );
}

export default LoginPage;
